import { useEffect, useRef, useState } from "react";
import { getVendorTimeSlots } from "../../../services/vendorSlotsService";
import { dateToYmd } from "./bookingStepperUtils";

// 'YYYY-MM-DD' of what the screen holds as the date (a string once a slot was clicked, a Date
// straight after the date picker).
export const ymdOf = (date) => {
  if (!date) return "";
  if (date instanceof Date) return Number.isNaN(date.getTime()) ? "" : dateToYmd(date);
  return String(date).split("T")[0];
};

/**
 * The time-slot list for the booking's day (service step Optional). Loads when `enabled` and
 * whenever the day, service, job length or the booking being edited changes; an answer that
 * arrives after a newer request was made is dropped.
 *   returns { data, loading, error }   data = { slots, closed, ... } or null
 */
export default function useVendorTimeSlots({ enabled, date, serviceId, duration, excludeGroupId }) {
  const [state, setState] = useState({ data: null, loading: false, error: "" });
  const latest = useRef(0);
  const day = ymdOf(date);

  useEffect(() => {
    if (!enabled || !day) {
      latest.current += 1;
      setState({ data: null, loading: false, error: "" });
      return undefined;
    }
    const request = ++latest.current;
    setState((s) => ({ ...s, loading: true, error: "" }));
    // a short pause so a quick succession of changes (date, then offerings) makes one request
    const timer = setTimeout(async () => {
      try {
        const res = await getVendorTimeSlots({ date: day, serviceId, duration, excludeGroupId });
        if (request !== latest.current) return;
        if (res?.success && res.data) setState({ data: res.data, loading: false, error: "" });
        else setState({ data: null, loading: false, error: res?.message || "Could not load the available times" });
      } catch (err) {
        if (request === latest.current) setState({ data: null, loading: false, error: err?.message || "Could not load the available times" });
      }
    }, 150);
    return () => clearTimeout(timer);
  }, [enabled, day, serviceId, duration, excludeGroupId]);

  return state;
}
